import LightCard from "../../../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import React from "react";
import {useTranslation} from "react-i18next";
import {categoryInstruments, isObjectEmpty} from "../../../../../../../../helpers/tools";
import InstrumentsList from "./InstrumentsList";
import OthersList from "./OthersList";
import { instrNameCol1, instrNameCol2, instrNameCol3, instrNameCol4} from "../../../../../../../../helpers/dictionary/users";

const category_trans = {
    Strings: "project.lineup.strings_title",
    Woods: "project.lineup.woods_title",
    Brass: "project.lineup.brass_title",
    Additional: "project.lineup.additional_title",
    Others: "project.lineup.other_musicians_title",
}

const categoryToInstrumentGroup = {
    Strings: instrNameCol1,
    Woods: instrNameCol2,
    Brass: instrNameCol3,
    Additional: instrNameCol4
};


const getMusicianSummary = (categoryName, staff) => {
    const instrumentGroup = categoryToInstrumentGroup[categoryName];
    if (!instrumentGroup) {
        return `${categoryName}: No instruments assigned to this group.`;
    }

    // Obliczenie całkowitej liczby muzyków wymaganych w grupie instrumentów
    const totalMusicians = instrumentGroup.reduce((sum, instrument) => {
        return sum + (parseInt(staff[instrument]) || 0);
    }, 0);
    return totalMusicians > 0
};


export default function CategoryList({staff, musiciansList, musicians, dispatch, othersMusicians, otherMusiciansList}) {
    const {t} = useTranslation()

    return <>
    {
        categoryInstruments.map((category, index) => {
            const shouldRenderCategory = getMusicianSummary(category.name, staff);

            return shouldRenderCategory ? (
                <LightCard classNames={'mt-4'} key={"category_" + index}>
                    <RedHeader title={t(category_trans[category.name])} />
                    {category.name === 'Others'
                        ? <div className='row px-2' key={index}>
                            <OthersList
                                others={staff["others"]}
                                othersMusicians={othersMusicians}
                                musiciansList={musiciansList}
                                dispatch={dispatch}
                                otherMusiciansList={otherMusiciansList}
                                // instruments={instruments}
                            />
                        </div>
                        : <div className='row px-2' key={index}>
                            <InstrumentsList
                                staff={staff}
                                musiciansList={musiciansList}
                                musicians={musicians}
                                category={category}
                                dispatch={dispatch}
                            />
                        </div>
                    }
                </LightCard>
            ): null
        })
    }
    </>
}


